import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-slides', 'titleNav', 'Slaidide navigeerimine');
Labels.set('ui-slides', 'prev', 'Eelmine');
Labels.set('ui-slides', 'next', 'Järgmine');
Labels.set('ui-slides', 'slide', 'Slaid');
